// extracted by mini-css-extract-plugin
module.exports = {"btn":"Button_btn__2FG5k","btnPrimary":"Button_btnPrimary__H8xTS","btnSecondary":"Button_btnSecondary__3kyuR","btnTertiary":"Button_btnTertiary__3WVt5"};